import React from 'react'
import ButtonSubstract from '../ActionButtons/ButtonSubstract'
import ButtonAdd from '../ActionButtons/ButtonAdd'
import InputV2 from '../InputV2'

const Stepper = ({
  value,
  onChange,
  onAdd,
  onSubstract,
  min = '0',
  max = '99',
}) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
      <ButtonSubstract onClick={onSubstract} />
      <InputV2
        type="int"
        value={value}
        min={min}
        max={max}
        onChange={onChange}
        width="32px"
      />
      <ButtonAdd onClick={onAdd} />
    </div>
  )
}

export default Stepper
